export enum LanguagesKey {
  AR = 'ar',
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  IT = 'it',
}
